import { render, staticRenderFns } from "./jInvitation.vue?vue&type=template&id=66f1ab33&scoped=true"
import script from "./jInvitation.vue?vue&type=script&lang=js"
export * from "./jInvitation.vue?vue&type=script&lang=js"
import style0 from "./jInvitation.vue?vue&type=style&index=0&id=66f1ab33&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f1ab33",
  null
  
)

export default component.exports